import { render, staticRenderFns } from "./Mailgun.vue?vue&type=template&id=1cae4e87&scoped=true"
import script from "./Mailgun.vue?vue&type=script&lang=js"
export * from "./Mailgun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cae4e87",
  null
  
)

export default component.exports